import { profileEn } from "@/module/Profile/locale/ProfileLocaleEn.js";

export const en = {
    default: {
        search: 'Search',
        confirm: 'Confirm',
        ok: 'OK',
        cancel: 'Cancel',
        close: 'Close',
        retry: 'Retry',
        btn_coupon: 'My coupon',

        error_title: 'We’re sorry',
        no_internet: 'Please try again',
        btn_try_again: 'Try again',
    },
    header: {
        placeholder: 'Search'
    },
    profile: profileEn,
    date: {
        days: 'day',
        months: 'month',
        years: 'year',
        minutes: 'minute',
        minutes_short: 'min',
        hours: 'hour',
        hours_short: 'hr',
        date_flase: 'Please select your birthday.',
        month_full: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
        month_short: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
        month_full_arr: [{ strvalue: "01", strtext: 'January' },
        { strvalue: '02', strtext: 'February' },
        { strvalue: '03', strtext: 'March' },
        { strvalue: '04', strtext: 'April' },
        { strvalue: '05', strtext: 'May' },
        { strvalue: '06', strtext: 'June' },
        { strvalue: '07', strtext: 'July' },
        { strvalue: '08', strtext: 'August' },
        { strvalue: '09', strtext: 'September' },
        { strvalue: '10', strtext: 'October' },
        { strvalue: '11', strtext: 'November' },
        { strvalue: '12', strtext: 'December' }],
        months_all: 'All',
        years_all: 'All'
    },
    redeem_button: {
        default: 'Redeem',
        draw: 'ลุ้นรางวัล',
        isLoading: 'กำลังดำเนินการ',
        none: '',
        soldOut: 'This reward has reached the user limit',
        soldOutBuy: 'This reward has reached the user limit',
        maxPerPerson: 'You’ve redeemed this reward',
        redeemCoolDown: 'You’ve redeemed this reward',
        nextDate: '<br/>at : ',
        exceedBuyPointLimitPerday: '',
        conditionIsInvalid: 'This reward requires user action before redemption. Please see details first.',
        campaignExpired: 'This reward has expired',
        campaignExpiredBuy: 'This reward has expired',
        campaignNotAvailable: 'Sorry. This reward is not available',
        campaignNotAvailableBuy: 'Sorry. This product is not available',
        notEnoughPoint: 'Not enough points to redeem',
        notEnoughCredit: 'Not enough credits to redeem',
        notSupport: 'This campaign is not support.',
        notPublish: 'Sorry. This reward is not available',
        exceedQuota: 'Quota full',
        notAmbassador: 'This reward requires user action before redemption. Please see details first.',
        userPrestige: 'Your current tier isn’t included in this reward',
        unableProceed: 'Unable to proceed',
        notAvailableTier: 'This reward is for AIA Prestige only. Tap below to see information.',
        explor: 'Explore AIA Prestige',
        remaining: 'Remaining balances',
        use: 'Use',
        credits: 'Credit',
        // WI #878678 mapping text key: no_level_block (Proposed text, pending confirm Q2)
        noLevelBlock: 'Unable to redeem right now. Please try again later.'
    },
    confirm_redeem: {
        confirm: "Confirm",
        cancel: "Cancel",

        group: {
            '1': {
                headline: 'Do you want to redeem for yourself or transfer to another person?',
                message: 'You’ll need to provide recipient details to get confirmation', //Redeem or transfer privileges to the other person
                btnPrimary: 'For myself',
                btnSecondary: 'Transfer'
            },
            '2': {
                headline: 'Do you want to redeem for yourself or transfer to another person?',
                message: 'You’ll need to provide recipient details to get confirmation', //Redeem or transfer privileges to the other person
                btnPrimary: 'For myself',
                btnSecondary: 'Transfer'
            },
            '3': {
                headline: 'Do you want to redeem for yourself or transfer to another person?',
                message: 'You’ll need to provide recipient details to get confirmation', //Redeem or transfer privileges to the other person
                btnPrimary: 'For myself',
                btnSecondary: 'Transfer'
            },
            '4': {
                headline: 'Confirm registration<br/>{0}',
                viz_card: 'VIZ Card',
                grayson_card: 'Graysorn Card',
                message: '',//"You'll be taken to fill in your info,<br/>in the next screen.",
                btnPrimary: 'Confirm',
                btnSecondary: 'Cancel'
            },
            '5':{
                headline: 'Confirm your redeem', //'ยืนยันการรับสิทธิ์',
                headline_timer: 'The code will expire {0} after you confirm. Please use immediately.',
                message: '',//'Would you like to redeem this reward?',
                message_timer: '',
                btnPrimary: 'Confirm',
                btnSecondary: 'Cancel'
            },
            '6': {
                headline: 'Confirm your redeem', //'ยืนยันการรับสิทธิ์',
                headline_timer: 'The code will expire {0} after you confirm. Please use immediately.',
                message: '', //'Would you like to redeem this reward?',
                message_timer: '',
                btnPrimary: 'Confirm',
                btnSecondary: 'Cancel'
            },
            '8': {
                headline: 'Confirm your redeem',
                // viz_card: 'VIZ Card',
                // grayson_card: 'Graysorn Card',
                message: "",//"You'll be taken to fill in your info,<br/>in the next screen.",
                btnPrimary: 'Confirm',
                btnSecondary: 'Cancel'
            },
            '9': {
                headline: 'Confirm your redeem',
                btnPrimary: 'Confirm',
                btnSecondary: 'Cancel'
            },
            'default': {
                headline: 'Confirm your redeem', //'ยืนยันการรับสิทธิ์',
                headline_timer: 'The code will expire {0} after you confirm. Please use immediately.',
                message: '',//'Would you like to redeem this reward?',
                message_timer: '',
                btnPrimary: 'Confirm',
                btnSecondary: 'Cancel'
            },
            'ambassador': {
                message: 'Confirm your redeem',
                btnPrimary: 'Confirm',
                btnSecondary: 'Cancel'
            },
            'draw': {
                headline: 'ยืนยันการลุ้นรางวัล', //'ยืนยันการรับสิทธิ์',
                headline_timer: 'ยืนยันการลุ้นรางวัล',
                message: '',//'Would you like to redeem this reward?',
                message_timer: '',
                btnPrimary: 'Confirm',
                btnSecondary: 'Cancel'
            }
        },

        free: 'Serial will available for {0} after confirm',
        free_no_timer: 'Confirm your redeem',
        free_delivery: 'Please enter shipping information to redeem',
        draw: 'Confirm to join campaign <br/> Winner will be announced after {0}',
        draw_delivery: 'Please enter shipping information to redeem',
        deal: 'Serial will available for {0} after confirm',
        deal_no_timer: 'Confirm your redeem',
        deal_delivery: 'Please enter shipping information to redeem',
        buy: 'Confirm to purchase',
        buy_delivery: 'Please enter shipping information to buy',
        interface: 'This will redirect to website after confirm',
    },
    purchase: {
        show_code: 'view code',
        code_expired: 'This serial has expired.',

        redeem_date: 'Redeemed date : {0}',
        expire_date: 'Expired : {0}',

        delivery: 'Product will be mailed based on Campaign Condition.',
        shipped: 'The Product has been delivered.',
        parcel_no: 'ParcelNo',

        not_draw1: 'Not yet drawn,',
        not_draw2: 'please check back at a later date',
        draw_winner1: 'You are the winner',
        draw_winner2: '',
        draw_not_win1: 'Sorry you are not the winner,',
        draw_not_win2: 'better luck next',

        status_available: 'Show code',
        status_cancelled: 'cancelled',
        status_expired: 'Expired',
        status_used: 'used',
        status_refill: 'Not successful, please fill out more information',
        status_transfered: 'Transfer',
        status_group_8: 'Not successful, please fill out more information',
        status_min_match: 'Your status changed. Please contact AIA Prestige Line Tel. 02 353 8900.'
    },
    serial: {
        refill_line_1: 'Your registration is not complete',
        refill_line_2: 'Please fill your personal information and click "Send"',
        refill_btn: 'Please fill more details',
        refill_group_8: 'Your registration is not complete, please fill out your information and click "send information" ',

        close_btn: 'Close',
        show_code_at_shop: 'Please show the {0} to the staff at the service point.',
        group_one_show_code: 'Please show code from "My Coupon" menu to staff<br/>on the day of your scheduled service.',
        group_five_show_code: 'Please show code to staff at the counter /<br/>check your privilege at "My Coupon" menu. ',

        delivery: 'Product will be mailed based on Campaign Condition.',

        draw: 'Thank you for joining us.<br/>Winner will be announced after {0}',
        draw_after: 'after',

        qr_code: 'QR code',
        barcode: 'Barcode',
        code: 'Code',

        copy_code: 'Copy Code',
        copy_success_title: 'Successfully copied code',

        expire_in: 'Expires within: ',
        code_expired: 'This serial has expired.',
        day: 'DAY',

        redeem_on: 'Redeemed date : {0}',

        group_one_redeem_on: 'Redeemed date : {0}',
        group_five_redeem_on: 'Redeemed date : {0}',

        footer_close: 'Continue',
        footer_cancel_redemption: 'Cancel redemption/<br/>Transfer privilege',
        footer_cancel_group_9: 'Cancel redemption',

        cancel: 'Cancelled',
        expired: 'Expired',
        used: 'Used',
        transfer: 'Transfer',
        min_match: 'Your status changed. Please contact AIA Prestige Line Tel. 02 353 8900.',

        cancel_title: 'Confirm to cancel redeeming',
        cancel_msg: '',
        cancel_no: 'Cancel',
        cancel_yes: 'Confirm',

        cancel_success_title: 'Please fill out more information<br/>to receive SMS / Email confirmation to cancel',
        cancel_success_msg: "",
        cancel_ok: 'Confirm',
        error_msg: 'การยกเลิกและคืนสิทธิ<br/>ต้องไม่น้อยกว่า 7 วัน<br/>นับจากวันสิ้นสุดการจอง',
        redeem_success: "Successfully redeemed",
        redeem_expire: "Unable to redeem, code expired.",
        btn_privilege: "Back to Privilege",
        btn_coupon: "My coupon"
    },
    gift_serial: {
        show_code_at_shop: 'แสดง{0}กับพนักงานที่หน้าร้าน',

        qr_code: 'คิวอาร์โค้ด',
        barcode: 'บาร์โค้ด',
        code: 'รหัส',

        copy_code: 'คัดลอกรหัส',
        copy_success_title: 'คัดลอกรหัสสำเร็จ',

        expire_in: 'หมดอายุภายใน : ',
        day: 'วัน',

        redeem_on: 'วันที่รับสิทธิ : {0}',

        cancel: 'ยกเลิก',
        expired: 'หมดอายุ',
    },
    draw_delivery: {
        title: 'ขอบคุณที่ร่วมสนุกกับเรา',
        msg: 'กรุณาติดตามประกาศผลรางวัลเร็วๆนี้',
        announcement_btn: 'ประกาศผลรางวัล'
    },
    redeem_success: {
        group: {
            '1': {
                headline: 'Please fill out your information to receive<br/>SMS / Email confirmation to redeem',
                message: "",
                btnPrimary: 'Confirm',
                btnSecondary: 'NO'
            },
            '2': {
                headline: 'Please fill out your information to receive<br/>SMS / Email confirmation to redeem',
                message: "",
                btnPrimary: 'Confirm',
                btnSecondary: 'NO'
            },
            '3': {
                headline: 'Please fill out your information to receive<br/>SMS / Email confirmation to redeem',
                message: "",
                btnPrimary: 'Confirm',
                btnSecondary: 'NO'
            },
            '4': {
                headline: 'Successfully Redeemed Reward',
                message: "You'll be forward to the next screen",
                btnPrimary: 'OK',
                btnSecondary: 'NO'
            },
            '5':{
                headline: 'Successfully redeemed',
                message: "",
                btnPrimary: 'My Coupon',
                btnSecondary: 'Close'
            },
            '6': {
                headline: 'Successfully redeemed',
                message: "",
                btnPrimary: 'My Coupon',
                btnSecondary: 'Close'
            },
            '9': {
                headline: 'Please fill out your information to receive<br/>SMS / Email confirmation to redeem',
                message: "",
                btnPrimary: 'Confirm',
                btnSecondary: 'NO'
            },
            'default': {
                headline: 'Successfully Redeemed Reward',
                message: "You'll be forward to the next screen",
                btnPrimary: 'OK',
                btnSecondary: 'NO'
            },
            'ambassador': {
                headline: 'Successfully Redeemed Reward',
                message: "You'll be forward to the next screen",
                btnPrimary: 'OK',
                btnSecondary: 'NO'
            },
        }
    },
    shipping: {
        headline: 'Shipping address',

        firstname: {
            name: 'Firstname',
            placeholder: 'Firstname',
            required: 'Please enter firstname',
            too_short: '',
            invalid: '',
        },
        lastname: {
            name: 'Lastname',
            placeholder: 'Lastname',
            required: 'Please enter lastname',
            too_short: '',
            invalid: '',
        },
        address:  {
            name: 'Address',
            placeholder: 'Address',
            required: 'Please enter address',
            too_short: '',
            invalid: '',
        },
        contactnumber: {
            name: 'Contact number',
            placeholder: 'Contact number',
            required: 'Contact number',
            too_short: 'Contact number must be {0} digits',
            invalid: 'Incorrect contact number format',
        },
        nationalid: {
            name: 'National id',
            placeholder: 'National id',
            required: 'Please enter national id',
            too_short: 'National id number must be {0} digits',
            invalid: 'Incorrect national id format',
        },
        email: {
            name: 'Email',
            placeholder: 'Email',
            required: 'Please enter email address',
            too_short: '',
            invalid: 'Incorrect email format',
        },
        zipcode: {
            name: 'Zipcode',
            placeholder: 'Zipcode',
            required: 'Please enter zipcode',
            too_short: 'Zipcode must be {0} digits',
            invalid: 'Invalid zipcode',
        },
        subdistrict: {
            name: 'Sub district',
            placeholder: 'Please selece sub-district',
            required: 'Please selece sub-district',
            too_short: '',
            invalid: '',
        },
        district: {
            name: 'District',
            placeholder: 'Please selece district',
            required: 'Please selece district',
            too_short: '',
            invalid: '',
        },
        province: {
            name: 'Province',
            placeholder: 'Please selece province',
            required: 'Please selece province',
            too_short: '',
            invalid: '',
        },

        save_address: 'Save address for next privilege',
        save_address_buy: 'Save address for next puchase',

        confirm_btn: 'Confirm',
        cancel_btn: 'Cancel',

        alert_headline: 'Shipping address',
        alert_ok_btn: 'OK',
    },
    main: {
        home_page: "Home",
        login: "Login",
        campaign: "Campaign",
        category: 'Category',
        map: "Map",
        terms: "Terms And Conditions",
        history: 'History',
        profile: "Profile",
        logout: "Logout",
        lang: "Language",
        msgLogout: "Logout ?",
        cancel: "Cancel",
    },
    campaign: {
        point: 'Point',
        get_point: 'Get Point : ',
        use_point: 'Use Point : ',
    },
    detail: {
        mass_headline: 'Privileges',
        prestige_headline: 'Privileges',
        expire_date: 'หมดอายุ : {0}',
        reward_detail: 'Reward detail',

        detail: 'Details',
        condition: 'Conditions',
        duration: 'Duration',

        point: 'Point',
        get_point: 'Get Point : ',
        use_point: 'Use Point : ',
        available_date: 'Date',

        color: {
            name: 'Color',
            placeholder: 'Please select color',
            required: 'Please select color',
        },
        size: {
            name: 'Size',
            placeholder: 'Please select size',
            required: 'Please select size',
        },

        quota_not_available: 'ไม่พบข้อมูลโควต้า',

        max_group_4: 'Unsuccessfully registered',
        msg_max_group_4: 'Please select My coupon to proceed',
        err_409_maximum_quota: 'ขออภัย สิทธิคงเหลือของท่าน<br/>ไม่เพียงพอสำหรับรับเอกสิทธิ์นี้',

        send_to_friend_title: 'Please fill out your information<br/> to receive SMS / Email<br/>confirmation to transfer',//'Confirm to send reward to your friend',
        send_to_friend_msg: "",
    },
    history: {
        date_select_placeholder: 'ทั้งหมด',
        burn_tab: 'Unused coupon',
        used_tab: 'Used coupon',

        point: 'คะแนน',
        get_point: 'ได้คะแนน : ',
        use_point: 'ใช้คะแนน : ',

        parcel_number: 'เลขพัสดุ : ',

        empty_list: 'Information not found'
    },
    home: {
        ambassador: 'แอมบาสเดอร์',
        tier_lvl: {
            'c': 'ระดับ คลาสสิค',
            's': 'ระดับ ซิลเวอร์',
            'g': 'ระดับ โกลด์',
            'p': 'ระดับ แพลทินัม'
        },
        see_all: 'View all'
    },
    reward: {
        expire_date: 'Expiry date : {0}',
        quota: 'Remaining quota : Up to {0} per year',
        quota_month: 'Remaining quota : Up to {0} per year</br>(all partners included)',
        quota_year: 'Remaining quota : Up to {0} per year</br>(all partners included)',
        quota_year_not_allies: 'Remaining quota : Up to {0} per year',
        quota_season: 'Remaining quota : Up to {0}  per season (all matches included)',
        quota_life_time: 'Remaining quota : Up to {0} per membership',
        quota_per_hour: 'Remaining quota : {0} Hours',
        no_data: 'Information not found',

        search_history: 'Recent search',
        search_result: 'Search results : ',

        start_date_lbl: 'Start on {0}',
        end_date_lbl: 'Expire on '
    },
    about_us: {
        mass: {
            tel: 'Contact AIA Call Center',
            tel_content: '1581',
            tel_number: '1581',
            term: "Term of use for AIA Prestige Club's privileges",
            faq: 'FAQs '
        },
        prestige: {
            tel: 'Contact AIA Prestige Line at',
            tel_content: '0 2353 8900',
            tel_number: '0-2353-8900',
            open_web: 'AIA Prestige Club website',
            open_web_content: 'aia.co.th/prestigeclub',
            email: 'AIA Prestige Club email',
            email_content: 'th.prestigeclub@aia.com',
            email_address: 'th.prestigeclub@aia.com',
            term: 'Terms and Conditions of Prestige Club  Membership and enhancement of membership status',
            privilege: 'Terms of Privileges Usage of Prestige Club Membership',
            faq: 'FAQs'
        },
        open_web_address: 'https://www.aia.co.th/prestigeclub',
    },
    faq: {
        headline: 'Frequently Asked Questions',
        mass_question: [
            {
                q: 'How can I check my benefit history:',
                a: 'You can check the details in the "My Coupon" menu.',
            },
            {
                q: "Where will the code be stored if I have claimed the benefit but haven't used it yet?",
                a: 'The claimed benefits will be saved in the "My Coupon" menu, categorized into unused and used/expired coupons.',
            },
            {
                q: 'How can I claim additional benefits or use a benefit twice at the same time?',
                a: 'If you still have remaining benefits, you can claim additional benefits immediately by following the usual claiming method. You can check the claimed coupons in the "My Coupon" menu.',
            },
            {
                q: 'Can I cancel a claimed benefit?',
                a: 'Cancellation is not possible because the special benefits have a usage period after being claimed. Therefore, you cannot cancel or compensate for unused benefits after the specified period.',
            },
            {
                q: 'Where can I ask about AIA products or services?',
                a: '1. Website : <a href="https://www.aia.co.th">www.aia.co.th</a><br/>2. AIA Call Center: Tel. <a href="tel:1581">1581</a><br/>3. AIA Agents',
            },
            {
                q: 'What should I do if I encounter issues with claiming special benefits or using the application?',
                a: 'Contact AIA Call Center at Tel. <a href="tel:1581">1581</a>',
            }
        ],
        prestige_question: [
            {
                q: 'How can I check my Prestige Status Level, privileges and number of benefits received?',
                a: 'You can check more details in "Member Information" menu. ',
            },
            {
                q: 'How can I check my benefit history? ',
                a: 'You can check the details in the "My Coupon" menu.',
            },
            {
                q: "If I have accepted a benefit but haven't used it yet, where is the code stored?",
                a: 'Accepted privileges will be recorded in the "My Coupon" menu, categorized as unused and used/expired coupons.',
            },
            {
                q: 'How can I claim additional benefits or use two benefits simultaneously?',
                a: "If you have remaining benefits, you can claim additional benefits immediately by following the normal claim procedure. You can check the coupons you've claimed in the 'My Coupon' menu.",
            },
            {
                q: 'Which types of privileges need to be claimed in advance and scheduled before the service date?',
                a: 'Privilege Annual Health Check-up, Limousine services, Golf Cart Service and Fast Track Immigration Lane and participation in various activities.',
            },
            {
                q: 'Can I cancel a claimed benefit?',
                a: 'Privileges that need to be claimed in advance, such as Annual Health Check-up services, Limousine services, Golf Cart Service and Fast Track Immigration Lane and participation in various activities, can be canceled according to the conditions of each privilege. Please carefully read the terms of use again. Cancellation can be done through "My Coupon" menu. Privileges with a set usage period after claiming, such as movie tickets, fitness services, Airport Lounge or other partner services, cannot be canceled or compensated if not used within the specified period.',
            },
            {
                q: 'How can I change the phone number or email provided on the day of claiming a privilege?',
                a: 'Please cancel the claimed privilege by going to the "My Coupon" menu and claim it again.',
            },
            {
                q: 'Can Health Check-up service privileges still be transferred to family members?',
                a: 'Yes, Health Check-up service privileges can be transferred to family members.',
            },
            {
                q: 'What are the privileges and the number of privileges received for each status?',
                a: 'You can find details at <a href="https://www.aia.co.th/prestigeclub">www.aia.co.th/prestigeclub</a> under "Special Privileges" section.',
            },
            {
                q: 'What should I do if I encounter issues with claiming privileges or want to check my benefits?',
                a: 'Contact Prestige Customer Service Center at <a href="tel:023538900">0 2353 8900</a> , available daily from 8:00 AM to 8:00 PM.',
            },
            {
                q: 'Where can I find details about the AIA Prestige Club program?',
                a: '1. Prestige Club Member Handbook<br/>2. Website : <a href="https://www.aia.co.th/prestigeclub">www.aia.co.th/prestigeclub</a><br/>3. AIA Prestige Club Call Center: <a href="tel:023538900">0 2353 8900</a> , available daily from 8:00 AM to 8:00 PM<br/>4. AIA agents',
            }
        ]
    },
    terms: {
        terms_headline: {
            mass: 'ข้อกำหนดการใช้สิทธิพิเศษของเอไอเอ',
            prestige: 'ข้อกำหนดการถือครองสิทธิ การต่ออายุ และยกระดับ<br/>สถานะในโครงการเอไอเอ เพรสทีจ คลับ'
        },
        privilege_headline: 'ข้อกำหนดการใช้เอกสิทธิ์ภายใต้<br/>โครงการเอไอเอ เพรสทีจ คลับ',
    },
    error: {
        error_title: 'We’re sorry',
        error_msg: 'Something went wrong. Please try again.',
    }
};
